import { Alert, lighten, Button, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';

type MemberOverrideMessageProps = {
  onClickOverride: () => void;
  permission: string;
};

export const MemberOverrideMessage = (props: MemberOverrideMessageProps) => {
  const { onClickOverride, permission } = props;
  const { t } = useTranslation(['member']);
  const { currentUser } = useGlobals();

  return (
    <>
      {getPermission(currentUser, permission) && (
        <Alert
          severity='warning'
          variant='outlined'
          sx={{ backgroundColor: lighten(Colors.ChipColors.Yellow, 0.9), '& .MuiAlert-message': { width: '100%' }, mt: 1 }}
        >
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
              <Typography>{t('member:validation.confirmSkipValidationMessage')}</Typography>
            </Box>
            <Button variant='contained' size='large' sx={{ mt: 2 }} onClick={onClickOverride}>
              {t('member:validation.saveMember')}
            </Button>
          </Box>
        </Alert>
      )}
    </>
  );
};
